import React from 'react'
import { Switch, Route } from "react-router-dom"
import Plans from './plans.page'
import Create from './create/create.page'
import Edit from './edit/edit.page'
import './common.styles.scss'

const PlanController = () => {
    return (
        <div className="plan">
            <Switch>
                <Route path="/internet/plans/create" component={Create} />
                <Route path="/internet/plans/:id" component={Edit} />
                <Route path="/internet/plans" component={Plans} />
            </Switch>
        </div>
    )
}

export default PlanController